/**
 * Sliding window of page numbers for compact pagination.
 */
export function getVisiblePageNumbers(currentPage, lastPage, maxVisible = 5) {
  const last = Math.max(1, Number(lastPage) || 1);
  const windowSize = Math.min(maxVisible, last);
  const current = Math.min(last, Math.max(1, Number(currentPage) || 1));

  let start = Math.max(1, current - Math.floor(windowSize / 2));
  const end = Math.min(last, start + windowSize - 1);
  start = Math.max(1, end - windowSize + 1);

  const pages = [];
  for (let page = start; page <= end; page += 1) {
    pages.push(page);
  }
  return pages;
}
